// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7008 ? "b8e21824" : chunkId) + "." + {"5896":"5ff88d9e37409caa","7008":"640fa4633089ebae"}[chunkId] + ".js";
};